export const MODULOS = {

    INGRESOS_PUBLICOS: 30,
    ADMINISTRACION: 31,
    SEGURIDAD: 32,
    AUDITORIA: 33,
    TESORERIA: 35
    
}